import { findByIndex } from "../../helpers";

export const NCPApcts = ["NA.pct", "CA.pct", "PA.pct"];

const checkInfo = (key, value) => (char) => char[key] >= value;

export const checkAscs = {
  1: checkInfo("ascension", 1),
  4: checkInfo("ascension", 4)
};

export const checkCons = {
  1: checkInfo("constellation", 1),
  2: checkInfo("constellation", 2),
  4: checkInfo("constellation", 4),
  6: checkInfo("constellation", 6)
};

export const xtraTlLv = {
  cons3: (char) => (char.constellation >= 3 ? 3 : 0),
  cons5: (char) => (char.constellation >= 5 ? 3 : 0)
};

const makeTkDesc = (_) =>
  typeof _ === "string"
    ? _
    : `Self / ${_[0] ? "Ascension" : "Constellation"} ${_[1]} activated`;

export function makeTlBnes(first, field, desc, value) {
  if (Array.isArray(first)) {
    const result = {};
    first.forEach(([cond, field1, desc1, value1]) => {
      if (cond && value1) {
        result[field1] = {
          desc: makeTkDesc(desc1),
          value: value1
        };
      }
    });
    return result;
  }
  if (first && value) {
    return {
      [field]: { desc: makeTkDesc(desc), value }
    };
  }
  return {};
}

export function modIsOn(MCs, index) {
  const ctrl = findByIndex(MCs, index);
  return ctrl && ctrl.activated;
}

export const checkCharMC = (mods, char, charBCs, index) =>
  findByIndex(mods, index)?.isGranted(char) && modIsOn(charBCs, index);

export function findInput(MCs, ctrlIndex, inpIndex, defaultVal = 0) {
  const ctrl = findByIndex(MCs, ctrlIndex);
  return ctrl && ctrl.inputs ? ctrl.inputs[inpIndex] : defaultVal;
}

export function countElmts(charData, partyData) {
  const existed = [charData.vision];
  partyData.forEach(({ vision }) => {
    if (!existed.includes(vision)) existed.push(vision);
  });
  return existed.length;
}
